/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { CalculateFirstStepPayload, FunnelFirstStepDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class FunnelController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags funnel-controller
   * @name CalculateFirstStep
   * @request POST:/api/v1/funnel/calculate-first-step
   */
  calculateFirstStep = (data: CalculateFirstStepPayload, params: RequestParams = {}) =>
    this.http.request<FunnelFirstStepDto, any>({
      path: `/v1/funnel/calculate-first-step`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static calculateFirstStepPath = '/v1/funnel/calculate-first-step'
  static calculateFirstStepMethod = 'POST'
}
